/* jshint esnext: true */
import Scroll from '../modules/Scroll';
import SmoothScroll from '../modules/SmoothScroll';
import TransitionsManager from '../modules/TransitionsManager';

export default function(firstblood) {
    const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (firstblood) {
        new TransitionsManager();
    }

    if (iOS || window.matchMedia('(max-width: 1279px)').matches) {
        new Scroll({
            container: document,
            selector: '.js-scroll',
        });
    } else {
        new SmoothScroll({
            container: '.o-scroll',
            selector: '.js-scroll',
        });
    }
}
